import React, { FC } from "react";
import DraftEditor from "shared/components/DraftEditor";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import Switch from "shared/components/Form/Switch";
import UploadImageField from "shared/components/Form/UploadImageField";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { useBroadcastDetails } from "../../context";
import SkeletonBroadcastContent from "./skeleton";

const General: FC = () => {
  const {
    imageFile,
    setImageFile,
    isLoadingImageFile,
    imageShown,
    setImageShown,
    isLoadingBroadcastDetails,
    editorContent,
    handleEditorChange,
    isReadOnlyMode,
  } = useBroadcastDetails();

  const handleImageShownChange = (checked: boolean) => {
    setImageShown(checked);
    if (!checked) {
      setImageFile(null);
    }
  };

  return (
    <ContentSection title="General">
      {isLoadingBroadcastDetails && <SkeletonBroadcastContent />}
      {!isLoadingBroadcastDetails && (
        <FlexColumn rowGap={"1rem"}>
          <Switch
            label="Show Image"
            value={imageShown}
            onChange={handleImageShownChange}
            disabled={isReadOnlyMode}
          />

          {imageShown && (
            <UploadImageField
              imageFile={imageFile}
              setImageFile={setImageFile}
              label={"Image"}
              isLoading={isLoadingImageFile}
              disabled={isReadOnlyMode}
            />
          )}

          <DraftEditor
            content={editorContent}
            label="Description*"
            onChange={handleEditorChange}
            placeholder="Enter a description of the broadcast..."
            hasEmojiToolbar
            disabled={isReadOnlyMode}
          />
        </FlexColumn>
      )}
    </ContentSection>
  );
};

export default General;
